export default __webpack_public_path__ + "static/media/revoke_icon.788bfd89.svg";